import React, { ReactElement } from 'react';
import Link from '@mui/material/Link';

const LinkPlain: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const TARGET_BLANK: string = '_blank';

  const {
    withNewWindow,
    link,
    onClick,
    children,
  } = props;

  return (
    <Link
      href={link}
      target={withNewWindow ? TARGET_BLANK : undefined}
      onClick={onClick || null}
    >
      {children}
    </Link>
  );
});

export default LinkPlain;
